var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1260 382L1260 410",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1260.5,
    cy: 377.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1255.99 377.19C1255.99 373.283 1259.29 370.117 1263.36 370.117C1263.94 370.117 1264.51 370.184 1265.06 370.308C1263.74 369.48 1262.19 369 1260.52 369C1255.81 369 1252 372.806 1252 377.5C1252 382.194 1255.81 386 1260.52 386C1262.81 386 1264.89 385.093 1266.43 383.62C1265.49 384.032 1264.45 384.263 1263.36 384.263C1259.29 384.263 1255.99 381.096 1255.99 377.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1269.4 376.6L1269.37 374.146L1267.54 375.719L1265.3 375.056L1266.11 377.337L1264.77 379.381L1267.1 379.218L1268.5 381.144L1269.13 378.763L1271.34 377.909L1269.4 376.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch6);
export default __webpack_public_path__ + "static/media/church_6.af392873509dec3977f5a2d4d8a1269b.svg";
export { ForwardRef as ReactComponent };